import { render, staticRenderFns } from "./trans-biddingtime-info.html?vue&type=template&id=e4489120&scoped=true&external"
import script from "./trans-biddingtime-info.js?vue&type=script&lang=js&external"
export * from "./trans-biddingtime-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-biddingtime-info.scss?vue&type=style&index=0&id=e4489120&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4489120",
  null
  
)

export default component.exports